require('es6-shim');
import biLogger from '@wix/web-bi-logger';

export const bi = biLogger.factory({endpoint: 'updates'}).setDefaults({src: 19}).logger();

export const logger = data => {
  bi.log(data);
};
